import BackButton from 'components/backButton'
import { Spinner } from 'components/common'
import { useSafeBack } from 'hooks'
import { useEffect, useState } from 'react'
import { Helmet } from 'react-helmet'
import { useNavigate, useParams } from 'react-router-dom'
import { OrderType } from 'types/order'
import { fetchPosOpenOrder } from 'utils/api/openOrderApi'
import {
  ORDER_TABLE_FIELDS,
  PAGE_NOT_FOUND,
  PAGE_POS_OPEN_ORDERS,
} from 'utils/constants'
import OpenOrderDetailsSection from './openOrderDetailsSection'

const { ORDER_NO } = ORDER_TABLE_FIELDS

const OpenOrderDetailsPage = () => {
  const navigate = useNavigate()
  const { orderId: orderNo } = useParams()

  const [order, setOrder] = useState<OrderType>()
  const [loading, setLoading] = useState<boolean>(true)

  const getOrderDetails = async (orderId: string) => {
    try {
      const { data } = await fetchPosOpenOrder(orderId)
      setOrder({ ...data })
    } catch (error) {
      navigate(PAGE_NOT_FOUND.path)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    if (orderNo) {
      getOrderDetails(orderNo)
    }
  }, [orderNo])

  const redirectToOpenOrdersPage = useSafeBack(PAGE_POS_OPEN_ORDERS.path)

  if (loading) {
    return <Spinner />
  }

  return (
    <>
      <Helmet>
        <title>GAG Aggregator | Open Order Detail</title>
      </Helmet>

      <div className="flex items-center justify-between">
        <BackButton handleBack={redirectToOpenOrdersPage} />
      </div>

      {order && ORDER_NO.value in order && (
        <OpenOrderDetailsSection order={order} />
      )}
    </>
  )
}

export default OpenOrderDetailsPage
